<template>
	<!-- eslint-disable vue/no-parsing-error eslint-disable vue/valid-v-on  -->
	<div :class="['lnk-quickfilter',themeClass,dutyClass]" v-show="filters && filters.length">
		<div class="lnk-quickfilter-left">
			<lnk-quickfilter-item v-for="(filter,index) in showFilter" :key="index" v-bind="publicProps" :filter="filter" :options="filter.options" :index="index"/>
			<slot></slot>
			<el-collapse-transition>
				<div class="lnk-quickfilter-collapse" v-if="!!collapseFilter" v-show="showCollapse">
					<lnk-quickfilter-item v-for="(filter,index) in collapseFilter" :key="index+3" v-bind="publicProps" :filter="filter" :options="filter.options" :index="index+3"/>
				</div>
			</el-collapse-transition>
		</div>
		<div class="lnk-quickfilter-right" v-if="!!collapseFilter" @click="toggleCollapse">
			<span>{{showCollapse?'收起':'展开'}}</span>
			<link-icon :icon="showCollapse?'link-icon-up':'link-icon-down'"/>
		</div>
	</div>
</template>

<script>
	/* eslint-disable complexity,no-underscore-dangle */


	/**
	 @name: lnk-quickfilter 快速筛选组件
	 @createdby:HuangJian
	 @props:
	 label-width:String,筛选标签的宽度
	 type:String,类型，default:check; 可选项 check（多选）、radio（单选）、block（单选-块状）
	 options:Array,配置数组,default:[]
	 remote:String,远程配置链接 json格式要求为 {options:[……]}

	 @events:
	 change:筛选项变化时触发

	 @example:
	 options配置字段：
	 field-字段，
	 name-字段名，
	 notShowAll-不展示“全部”标签，默认展示
	 lov-值列表类型，
	 parentLov-父值列表类型，
	 parentLovVal-所对应父值列表的源代码
	 custom-自定义筛选类型

	 options配置示例：
	 [{
        field:'acctName',
        name:'客户类型',
        lov:'ACCT_TYPE',
        notShowAll:true,
        excludeLov: ['CRM', 'CRMAPP', 'DMS', 'DMSAPP']
        },{
        field:'acctLevel',
        name:'客户等级',
        lov:'ACCT_LEVEL',
        parentLov:'ACCT_TYPE',
        parentLovVal:'Dealer'
        },{
        field:'acctStatus',
        name:'状态',
        custom:[
        {name:'有效',val:'Y'},
        {name:'失效',val:'N'}
        ]
        }]
	 */

	import themeClass from '@mixins/theme-class';
	import LnkQuickfilterItem from "./lnk-quickfilter-item";

	export default {
		name: 'lnk-quickfilter',
		components: {LnkQuickfilterItem},
		// inject: {
		//     /* 用于刷新高度的句柄 */
		//     resizeHandler: {
		//         default(){
		//             return {};
		//         }
		//     }
		// },
		model: {
			prop: 'modelval',
			event: 'change'
		},
		mixins: [themeClass],
		props: {
			modelval: Array,

			/* 样式类型*/
			type: {
				type: String,
				default: 'check' /* check\radio\block*/
			},

			/* 配置数列*/
			options: {
				type: Array,
				default() {
					return [];
				}
			},

			/* 默认值*/
			defaultValue: Array,

			/* 远程配置链接*/
			remote: String
		},
		watch: {
			type: {
				immediate: true,
				handler: function (val) {
					if (val === 'check' || val === 'radio' || val === 'block') {
						this.init();
					}
				}
			},
			options: {
				immediate: true,
				handler: async function (val) {
					if (Array.isArray(val)) {
						if (JSON.stringify(val) === this.optionCache) return;
						this.resetOptions(val)
					}
				}
			},
			remote: {
				immediate: true,
				handler: function (val) {
					if (val && typeof val === 'string') {
						this.init();
					}
				}
			}
		},
		data() {
			return {
				/**
				 * 异步任务队列
				 * @author  韦胜健
				 * @date    2019/12/24 17:55
				 */
				asyncWorks: new this.$lv.$utils.AsyncWorks(),
				/*当前多出的筛选条件是否处于展开状态*/
				showCollapse: false,

				/* 多选的全选状态*/
				checkall: [],

				/* 字段信息*/
				filters: [],

				/* 筛选条件*/
				results: [],

				/* 接受条件变化的父组件名称*/
				parentName: null,

				/*配置缓存*/
				optionCache: null,
			};
		},
		computed: {
			resultsDefault() {
				var result = [];
				if (Array.isArray(this.defaultValue)) {
					result = linkTools.deepCopy(this.defaultValue);
				}
				return result;
			},
			dutyClass() {
				return this.filters.length < 1 ? 'off-duty' : 'in-duty';
			},

			/**
			 * filter item公共属性
			 * @author  韦胜健
			 * @date    2019/5/27 14:53
			 */
			publicProps() {
				return {
					results: this.results,
					type: this.type,
					handleChange: this.handleChange,
					getIndeterminate: this.getIndeterminate,
					checkall: this.checkall,
					onCheckAll: this.onCheckAll,
					class: ['filter-item', this.type]
				}
			},
			/**
			 * 不受展开收起控制展示的筛选信息
			 * @author  韦胜健
			 * @date    2019/5/27 14:47
			 */
			showFilter() {
				if (!this.filters) return []
				return this.filters.slice(0, 3)
			},
			/**
			 * 受展开收起控制展示的筛选信息
			 * @author  韦胜健
			 * @date    2019/5/27 14:47
			 */
			collapseFilter() {
				if (!this.filters || this.filters.length < 4) return null
				return this.filters.slice(3, this.filters.length)
			},
		},
		methods: {
			/**
			 * 重新设置options，这里之所以要 使用异步任务队列 AsyncWork 来处理，是因为
			 * 组件初始化的时候，如果options变化了多次，先变化的options的处理结果可能
			 * 会覆盖掉后变化的options的处理结果，所以这里使用 AsyncWork 处理，所有
			 * 对 options的处理放到异步任务队列中，当一个异步任务执行完毕之后，再执行下一个异步任务；
			 * @author  韦胜健
			 * @date    2019/12/25 10:29
			 */
			resetOptions(val) {
				this.asyncWorks.append(async () => {
					await this.initOptions(val, false);
					this.optionCache = JSON.stringify(val)
				})
			},
			/**
			 * @method：init
			 * @createdBy：HuangJian
			 * @params：
			 * @description：初始化
			 *
			 */
			async init() {
				this.$on('setFilterOptions', (arr) => {
					this.resetOptions(arr)
				});
				this.$on('setParentName', (val) => {
					if (val && typeof val === 'string') {
						this.parentName = val;
					}
				});
				if (this.remote && typeof this.remote === 'string') {
					this.fetchRemote(this.remote);
				} else {
					this.resetOptions(this.options)
				}
			},

			/**
			 * @method：initOptions
			 * @createdBy：HuangJian
			 * @params：
			 * arr:配置信息
			 * clearResults：清空筛选条件结果
			 * @description：初始化筛选项
			 *
			 */
			async initOptions(arr, clearResults = true) {
				const filters = [];
				const results = [];

				if (Array.isArray(arr)) {
					await Promise.all(arr.map(async (arrItem, i) => {
						let options = [];
						/* 自定义筛选项*/
						if (arr[i].custom && arr[i].custom.constructor === Array) {
							options = linkTools.deepCopy(arr[i].custom);
							/* 值列表筛选项*/
						} else if (arr[i].lov && typeof arr[i].lov === 'string') {
							const arrItem = arr[i]
							const {lovs} = await this.$lov.getLovData(arrItem.lov, arrItem.parentLov, arrItem.parentLovVal, arrItem.excludeLov)
							options = lovs
						}
						if (Array.isArray(options)) {
							filters.push({
								name: arr[i].name,
								field: arr[i].field,
								type: arr[i].type,
								operator: arr[i].operator,
								notShowAll: arr[i].notShowAll ? arr[i].notShowAll : false,
								options,
							});
							if (arr[i].notShowAll) {
								const initVal = options.length > 0 ? options[0].val : null;
								results.push(this.type === 'check' ? [] : initVal);
							} else {
								results.push(this.type === 'check' ? [] : null);
							}
						}
					}))
				}

				if (filters.length && this.resultsDefault.length) {
					if (this.type === 'check') {
						for (var i = 0; i < filters.length; i++) {
							var matchDefault = null;
							for (var j in this.resultsDefault) {
								var defaultVal = this.resultsDefault[j];
								if (defaultVal.field === filters[i].field
									&& Array.isArray(defaultVal.val)) {
									matchDefault = defaultVal;
									break;
								}
							}
							if (matchDefault) {
								results[i] = defaultVal.val;
							}
						}
					} else {
						for (var i = 0; i < filters.length; i++) {
							var matchDefault = null;
							for (var j in this.resultsDefault) {
								var defaultVal = this.resultsDefault[j];
								if (defaultVal.field === filters[i].field) {
									matchDefault = defaultVal;
									break;
								}
							}
							if (matchDefault) {
								results[i] = defaultVal.val;
							}
						}
					}
				}


				if (this.filters.length && !clearResults) {
					const oldFilters = this.filters;
					const oldResults = this.results;
					for (var j in filters) {
						var filter = filters[j];
						for (var k in oldFilters) {
							var oldFilter = oldFilters[k];
							if (filter.field === oldFilter.field) {
								results[j] = oldResults[k];
								break;
							}
						}
					}
				}
				this.filters = [];
				await this.$lv.nextTick()
				this.filters = filters;
				this.results = results;
				await this.$lv.nextTick()
				this.getLabelWidth()
			},

			/**
			 * @method：getLabelWidth
			 * @createdBy:HuangJian
			 * @date:2019/3/20
			 * @params：
			 * @description：计算标签标题的宽度
			 */
			getLabelWidth() {
				const labels = this.$el.querySelectorAll('.filter-label');
				let maxWidth = 0;
				labels.forEach((el) => {
					const span = el.querySelector('span')
					const width = span.offsetWidth
					maxWidth = maxWidth < width ? width : maxWidth;
				});
				maxWidth = Math.ceil(maxWidth) + 28;
				const contents = this.$el.querySelectorAll('.filter-content');
				labels.forEach((el) => el.style.width = maxWidth + 'px');
				contents.forEach((el) => el.style.marginLeft = maxWidth + 'px');
			},
			/**
			 * @method：getIndeterminate
			 * @createdBy：HuangJian
			 * @params：
			 * index：筛选项的索引
			 * @description：获取多选框不确定状态
			 *
			 */
			getIndeterminate(index) {
				if (typeof index !== 'number') {
					return false;
				}
				var limit
					= this.filters[index]
					&& this.filters[index].options
					&& this.filters[index].options.length;
				var len
					= this.results[index]
					&& this.results[index].length;
				this.checkall[index] = len > 0 && len === limit;
				return len > 0 && len < limit;
			},

			/**
			 * @method：onCheckAll
			 * @createdBy：HuangJian
			 * @params：
			 * val：全选按钮的值
			 * index：筛选项的索引
			 * @description：响应多选的全选按钮
			 *
			 */
			onCheckAll(val, index) {
				if (typeof index !== 'number') return;
				try {
					var limit
						= this.filters
						&& this.filters.length;

					var ref
						= val
						&& index < limit
						&& this.filters[index].options;

					if (!ref) {
						ref = [];
					}
					var arr = [];
					for (var i in ref) {
						arr.push(ref[i].val);
					}
					arr = linkTools.deepCopy(arr);
					Vue.set(this.results, index, arr);
				} catch (e) {

				}
			},

			/**
			 * @method：handleChange
			 * @createdBy：HuangJian
			 * @params：
			 * @description：处理筛选条件的变化
			 *
			 */
			handleChange() {
				var rslt = [];

				var filters = this.filters;
				var results = this.results;
				var type = this.type;

				/* 多选*/
				if (type === 'check') {
					for (var i in filters) {

						/* 没设置字段 默认跳过*/
						if (!filters[i].field) continue;

						/* 条件的数目*/
						var len
							= results[i]
							&& results[i].length;

						/* 可选条件总数*/
						var limit
							= this.filters[i]
							&& this.filters[i].options
							&& this.filters[i].options.length;

						/* 不选或勾选全部时，不筛选*/
						if (len === 0 || len === limit) {
							continue;
						}

						var obj = {
							id: filters[i].field,
							property: filters[i].field
						};

						if (filters[i].operator) {
							obj.operator = filters[i].operator;
						}

						/* 筛选的条件数目大于1时，采用 in 操作符*/
						if (results[i] && results[i].length > 1) {
							obj.operator = 'in';
							obj.value = '[' + results[i] + ']';
						} else {
							obj.value = String(results[i]);
						}
						rslt.push(obj);
					}

					/* 单选*/
				} else {
					for (var i in filters) {

						/* 没设置字段 默认跳过*/
						if (!filters[i].field) continue;

						/* 勾选全部 不做筛选*/
						if (!results[i]) {
							continue;
						}
						var obj = {
							id: filters[i].field,
							property: filters[i].field,
							value: results[i]
						};
						if (filters[i].operator) {
							obj.operator = filters[i].operator;
						}
						rslt.push(obj);
					}
				}
				this.$emit('change', rslt);
				if (this.parentName) {
					this.$dispatch(this.parentName, 'quickfilter-change', rslt);
				}
			},

			/**
			 * @method：fetchRemote
			 * @createdBy：HuangJian
			 * @params：
			 * url：链接
			 * @description：获取远程配置
			 *
			 */
			fetchRemote(url) {
				this.$http.post(url).then((data) => {
					var errorMsg = '加载远程配置失败';
					if (
						data
						&& typeof data === 'object'
						&& data.options
						&& Array.isArray(data.options)
					) {
						this.resetOptions(data.options)
					} else if (
						data
						&& typeof data === 'string'
					) {
						try {
							var obj = JSON.parse(data);
							if (
								obj
								&& obj.options
								&& Array.isArray(obj.options)
							) {
								this.resetOptions(obj.options);
							}
						} catch (e) {

							this.$message({type: 'error', message: errorMsg});
						}
					} else {
						this.$message({type: 'error', message: errorMsg});
					}
				}).catch((err) => {
					if (!err.response) {
						this.$message({type: 'error', message: '请检查服务链接是否正确！'});
						return;
					}
					if (err.response && err.response.status === 404) {
						this.$message({type: 'error', message: '远程配置信息不存在！'});
					}
				});
			},

			/**
			 * 切换多余filter的收起展开状态
			 * @author  韦胜健
			 * @date    2019/5/27 15:31
			 */
			async toggleCollapse() {
				this.showCollapse = !this.showCollapse
				!!this.showCollapse && this.$nextTick(() => this.getLabelWidth())
			},
		}
	};
</script>

<style lang="scss">
	.lnk-quickfilter {
		background: #FFFFFF;
		padding: 0;
		display: flex;
		align-items: stretch;
		position: relative;

		.lnk-quickfilter-left {
			flex: 1;
		}

		.clearfix:after {
			content: '';
			display: table;
			clear: both;
		}

		.filter-item {
			.filter-label {
				text-align: right;
				line-height: 20px;
				padding-right: 18px;
				-webkit-box-sizing: border-box;
				-moz-box-sizing: border-box;
				box-sizing: border-box;
				float: left;
				font-size: 12px;
				color: #2E384D;
				letter-spacing: 1px;
				white-space: nowrap;
			}

			.filter-content {
				.el-checkbox__label, .el-radio__label {
				}
			}
		}

		$types: (
			'block':10px,
			'check':16px,
			'radio':20px,
		);

		.filter-item {
			@each $key, $val in $types {
				&.#{$key} {
					& + .filter-item.#{$key}, & + .lnk-quickfilter-collapse > :first-child.filter-item.#{$key} {
						margin-top: $val;
					}
				}
			}
		}

		/*块状单选*/
		.filter-item.block {
			.filter-label {
				line-height: 24px;
				padding-right: 28px;
			}

			.filter-content {
				.el-radio {
					padding: 6px 12px;
					font-size: 12px;
					border-radius: 14px;
					margin: 0 8px 0 0;

					.el-radio__input {
						display: none;
					}

					.el-radio__label {
						padding: 0;
						letter-spacing: 1px;
						color: #2E384D;
					}
				}

				.el-radio.is-checked {
					background: #409EFF;
					color: #FFFFFF;
				}

				.el-radio.is-checked .el-radio__input.is-checked + .el-radio__label {
					color: #FFFFFF;
				}
			}
		}

		/*传统单选样式*/
		.filter-item.radio {
			.filter-label {
				line-height: 13px;
			}

			.filter-content {
				line-height: 12px;

				.fixmargin-top {
					margin-top: -12px;
				}

				.el-radio-group {
					line-height: 1;
				}

				.el-radio {
					margin: 12px 22px 0 0;

					.el-radio__label {
						font-size: 12px;
					}
				}

				.el-radio__label {
					letter-spacing: 1px;
					color: #2E384D;
				}
			}
		}

		/*传统多选样式*/
		.filter-item.check {
			.filter-label {
				line-height: 18px;
			}

			.filter-content {
				padding-top: 16px;

				.check-row {
					margin-top: -16px;
					line-height: 12px;

					.fixmargin-top {
						margin-top: -24px;
					}

					.el-checkbox.checkall {
						float: left;
						margin: 0 22px 0 0;
					}

					.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
						top: 4px;
					}

					.el-checkbox__label {
						font-size: 12px;
						letter-spacing: 1px;
						color: #2E384D;
						padding-left: 8px;
					}

					.el-checkbox-group {
						line-height: 12px;

						.el-checkbox {
							margin: 8px 24px 0 0;
						}
					}

					.el-radio.start {
						margin-left: 0;
					}
				}
			}
		}
	}

	.lnk-quickfilter.crm-color {
		.filter-item.block .filter-content .el-radio.is-checked {
			background: #1F74FF;
			color: #FFFFFF;
		}
	}

	@include themeify {
		.lnk-quickfilter-right {
			position: absolute;
			bottom: 16px;
			right: 16px;
			cursor: pointer;

			font-size: 12px;
			color: pl-var(color-primary);
			text-align: center;

			.link-icon {
				margin-left: 0.5em;
			}
		}
	}
</style>
